import React, { render } from 'preact';
import OfferBody from './OfferBody'
import Offers from './Offers';
import Footer from './Footer';
import GDPR from './GDPR';
import './App.css';

if (document.getElementById("offer-body")) {
    render(<OfferBody />, document.getElementById('offer-body'));
} else if (document.getElementById("offers-holder")) {
    render(<Offers />, document.getElementById('offers-holder'));
} else {


}

render(<GDPR />,document.getElementById("accept-cookies"));
render(<Footer />, document.getElementById('footer'));


